import { EndorsementKey, type EndorsementConfig } from '../../types';
import { selectCheckedEndorsements, selectEPLICoverageLimit, selectEPLIRetentionLimit } from '../../../../selectors/application';

export const config: EndorsementConfig = {
  endorsementKey: EndorsementKey.EpliCoverage,
  label: 'Employment Practices Liability Insurance (EPLI)',
  description:
    'Provides businesses protection from lawsuits filed by employees alleging wrongful acts that occurred during the employment process.',
  recommended: true,
};

const VALID_EPLI_LIMITS = ['50000/50000', '100000/100000', '250000/250000'];
const VALID_EPLI_RETENTIONS = ['2500', '5000', '10000'];

export const isEPLICoverageValid = (state: ReduxState) => {
  const isChecked = selectCheckedEndorsements(state).includes(EndorsementKey.EpliCoverage);
  if (!isChecked) return true;
  const coverageLimit = selectEPLICoverageLimit(state);
  const retentionLimit = selectEPLIRetentionLimit(state);
  const limitsValid = VALID_EPLI_LIMITS.includes(coverageLimit);
  const retentionValid = VALID_EPLI_RETENTIONS.includes(retentionLimit);
  return limitsValid && retentionValid;
};
